<template>
	<video-player
			class="video-player vjs-custom-skin"
			ref="videoPlayer"
			:playsinline="true"
			:options="playerOptions"
	></video-player>
</template>

<script>
	export default {
		name: "index",
		props: {
			src: {
				type: String,
				default: ''
			},
			poster: {
				type: String,
				default: './image/video_img.jpg'
			}
		},
		data() {
			return {
				playerOptions : {
					playbackRates: false, //播放速度
					autoplay: false, //如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 导致视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
						src: this.src //url地址
					}],
					poster: this.poster, //你的封面地址
					// width: document.documentElement.clientWidth, //播放器宽度
					notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: false,
						fullscreenToggle: true  //全屏按钮
					}
				}
			}
		},
		watch: {
			src(val) {
				this.playerOptions.sources.splice(0, 1, {
					type: '',
					src: val
				})
			}
		},
		mounted() {
			setTimeout(() => {
				document.querySelector("video").setAttribute("x5-video-player-type", "h5");
				document.getElementsByClassName('vjs-big-play-button')[0].setAttribute("title", "播放");
			}, 3000)

		}
	}
</script>

<style scoped>
	.video-player /deep/ .vjs-big-play-button {
		border: transparent;
		background-color: transparent;
	}

	.video-player /deep/ .video-js:hover .vjs-big-play-button {
		background-color: transparent;
	}

	.video-player /deep/ > .video-js .vjs-control {
		width: 2em;
	}

	.video-player /deep/ .vjs-mute-control {
		padding-left: 0;
		padding-right: 0;
	}

	.video-player /deep/ .vjs-progress-control {
		margin-left: 5px;
	}

	.video-player /deep/ .vjs-big-play-button .vjs-icon-placeholder::before {
		content: '';
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background-image: url("http://st.web36524.cn/yzcc/image/player.png");
		background-repeat: no-repeat;
		background-size: 45px;
		background-position: center;
		transition: all .3s;
		cursor: pointer;
	}

	.video-player /deep/ .vjs-icon-placeholder,
	.video-player /deep/ span,
	.video-player /deep/ .vjs-playback-rate,
	.video-player /deep/ .vjs-play-progress {
		color: #ffd06b;
	}

	.video-player /deep/ .vjs-play-progress {
		background-color: #ffd06b;
	}



	@media screen and (max-width: 750px) {
		.video-player /deep/ .vjs-big-play-button {
			height: 28px;
		}
	}

</style>